import styled from 'styled-components';
import { lightTheme } from '@/styles/themes/light';

const { fonts } = lightTheme;

export {
	PostureColumn,
	PostureDivider,
	PostureLabel,
	PostureImageWrapper,
	PostureImagesRow,
	PostureRowDivider,
	PostureImagesGrid,
	PostureGridDividers,
	PostureImageWrapperSmall,
	ExpandButton,
	StyledModal,
	ModalContent,
	ModalColumn,
	ModalColumnLabel,
	ModalDivider
} from '@/components/views/Report/KimLhc/Components/Shared/PostureDisplay/styles';

export const PostureGrid = styled.div`
	gap: 24px;
	width: 100%;
	display: grid;
	grid-auto-rows: 211px;
	grid-template-columns: repeat(2, minmax(0, 1fr));
`;

export const PostureCard = styled.div`
	border: 1px solid #d9d9d9;
	border-radius: 8px;
	background-color: #ffffff;
	transition: all 0.3s;
	overflow: hidden;
	height: 100%;

	&:hover {
		border-color: #2f54eb;
	}

	.ant-radio-wrapper-checked & {
		border-color: transparent;
		background-color: #e6eaf8;
	}

	.ant-radio-wrapper {
		margin: 0;
		width: 100%;
		height: 100%;
		display: flex;

		.ant-radio {
			display: none;
		}
	}

	& span.ant-radio + * {
		padding-left: 0;
		padding-right: 0;
		width: 100%;
		height: 100%;
		display: flex;
	}
`;

export const PostureCardContent = styled.div`
	padding: 24px;
	display: flex;
	flex-direction: row;
	align-items: stretch;
	gap: 24px;
	position: relative;
	height: 100%;
	width: 100%;
	border: 2px solid transparent;
	border-radius: 8px;
	transition: all 0.3s;

	.ant-radio-wrapper-checked & {
		background-color: #f0f5ff;
	}
`;

export const AdditionalFactorsContainer = styled.div`
	gap: 16px;
	display: flex;
	flex-direction: column;
`;

export const Divider = styled.div`
	width: 100%;
	height: 1px;
	margin: 8px 0;
	background-color: #e6e6e6;
`;

export const FactorDescriptionText = styled.span`
	font-size: ${fonts.label.md.fontSize} !important;
`;
